'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _avatar_default = require('@bibliocommons/assets/images/avatar_default.png');

var _avatar_default2 = _interopRequireDefault(_avatar_default);

require('../styles/UserAvatar.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_AVATAR_IMAGE = 'avatar_default.png';

var UserAvatar = function (_BcReactComponent) {
  _inherits(UserAvatar, _BcReactComponent);

  function UserAvatar() {
    _classCallCheck(this, UserAvatar);

    return _possibleConstructorReturn(this, (UserAvatar.__proto__ || Object.getPrototypeOf(UserAvatar)).apply(this, arguments));
  }

  _createClass(UserAvatar, [{
    key: 'renderAvatar',
    value: function renderAvatar() {
      var avatar = this.props.userIdentity.get('avatar');
      var coreCdnHost = this.context.coreCdnHost || '';
      var avatarURL = avatar === DEFAULT_AVATAR_IMAGE ? _avatar_default2.default : '' + coreCdnHost + avatar;

      return _react2.default.createElement('img', { src: avatarURL, className: 'img-circle', alt: '' });
    }
  }, {
    key: 'renderInitial',
    value: function renderInitial() {
      var initial = this.props.userIdentity.get('name').charAt(0);

      return _react2.default.createElement(
        'span',
        { className: 'img-circle initial' },
        _react2.default.createElement(
          'span',
          null,
          initial
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var userIdentity = this.props.userIdentity;

      var size = this.props.size || 'sm';
      var classNames = (0, _classnames2.default)('cp-user-avatar', 'avatar-' + size, { 'home-patron': userIdentity.get('homePatron') });
      var profileURL = '/user_profile/' + userIdentity.get('id');

      return _react2.default.createElement(
        'span',
        { className: classNames, 'aria-hidden': 'true' },
        _react2.default.createElement(
          'a',
          { className: 'user-avatar-link', href: profileURL },
          userIdentity.get('avatar') ? this.renderAvatar() : this.renderInitial()
        )
      );
    }
  }]);

  return UserAvatar;
}(_baseBcReactComponent2.default);

UserAvatar.propTypes = {
  size: _react.PropTypes.string,
  userIdentity: _bcPropTypes.userIdentityShape.isRequired
};

UserAvatar.contextTypes = {
  coreCdnHost: _react.PropTypes.string
};

exports.default = UserAvatar;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-avatar/lib/components/UserAvatar.component.js
// module id = 1549
// module chunks = 1